var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('b-form-invalid-feedback',{staticClass:"position-absolute",attrs:{"id":"input-live-feedback"}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }